import React, { useMemo } from "react";
import { RangePickerProps } from "antd/lib/date-picker";
import moment from "moment";
import { DatePicker } from "antd";
import { useTranslation } from "react-i18next";
const { RangePicker: AntRangePicker } = DatePicker;

type IProps = RangePickerProps;

export const currentMonth = moment();
export const lastMonth = moment().subtract(1, "month");

const RangePicker = (props: IProps) => {
  const { t } = useTranslation();
  const ranges = useMemo(
    () => ({
      [t("components.date_range.yesterday")]: [
        moment().subtract(1, "d"),
        moment().subtract(1, "d"),
      ],
      [t("components.date_range.today")]: [moment(), moment()],
      [t("components.date_range.last_n_days", { day: 7 })]: [
        moment().subtract(7, "d"),
        moment().subtract(1, "d"),
      ],
      [t("components.date_range.last_n_days", { day: 14 })]: [
        moment().subtract(14, "d"),
        moment().subtract(1, "d"),
      ],
      [t("components.date_range.last_n_days", { day: 28 })]: [
        moment().subtract(28, "d"),
        moment().subtract(1, "d"),
      ],
      [t("components.date_range.last_n_days", { day: 90 })]: [
        moment().subtract(90, "d"),
        moment().subtract(1, "d"),
      ],
    }),
    [t]
  );
  return (
    <AntRangePicker
      ranges={ranges as any}
      defaultPickerValue={[lastMonth, currentMonth]}
      {...props}
    />
  );
};

export default RangePicker;
